// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as VideoThumbnailCmp from "./VideoThumbnailCmp.bs.js";
import * as VideoPlaybackModal from "./VideoPlaybackModal.bs.js";

function PartnerScoreVideoContent(Props) {
  var title = Props.title;
  var desc = Props.desc;
  var video_url = Props.video_url;
  var variant = Props.variant;
  console.log([
        "Modal Video URL",
        video_url
      ]);
  var match = React.useState(function () {
        return false;
      });
  var setShowVideo = match[1];
  return React.createElement("div", {
              className: "c-partner-score-video-content__wrapper"
            }, React.createElement(VideoPlaybackModal.make, {
                  link: video_url,
                  close_modal: (function (param) {
                      return Curry._1(setShowVideo, (function (param) {
                                    return false;
                                  }));
                    }),
                  show_modal: match[0]
                }), React.createElement("div", {
                  className: "modal-video-content"
                }, React.createElement("div", {
                      className: "video-content"
                    }, React.createElement(VideoThumbnailCmp.make, {
                          setShowVideo: setShowVideo,
                          variant: variant
                        })), React.createElement("div", {
                      className: "text-content"
                    }, React.createElement("div", {
                          className: "c-partner-score-text-content__title"
                        }, title), React.createElement("div", {
                          className: "c-partner-score-text-content__desc"
                        }, desc))), React.createElement("div", {
                  className: "line-break"
                }));
}

var make = PartnerScoreVideoContent;

export {
  make ,
  
}
/* react Not a pure module */
